/* eslint-disable-next-line  no-unused-vars */
import React, { createElement, useEffect, useRef, useState, useContext } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LegendStatusItem from './LegendStatusItem';
import mapConfigHelper from '../helper/mapConfigHelper';
import './Legend.scss';
import applicationMode from '../helper/applicationMode';
import { MapContext } from '../map/MapContextProvider';

/*global google*/
export default function LegendComponent({ legendTitle, appMode }) {
    const { map, mapData } = useContext(MapContext);

    const [projectGroups, setProjectGroups] = useState();

    const [appModeShow, setAppModeShow] = useState(true);
    const legendRef = useRef();

    const mapHelper = new mapConfigHelper();

    useEffect(() => {
        if (appMode == applicationMode.default || appMode == applicationMode.custom) setAppModeShow(true);
        else setAppModeShow(false);

        map.controls[google.maps.ControlPosition.LEFT_TOP].clear();
        map.controls[google.maps.ControlPosition.LEFT_TOP].push(legendRef.current);

    }, []);


    useEffect(() => {
        let objList = mapHelper.getLegendArray(mapData);
        setProjectGroups(objList);
    }, [mapData]);

    return (
        <>
            {<div ref={legendRef}>
                {mapData.length > 0 && appModeShow && (
                    <div className="container-legend" >
                        {legendTitle && <div className="legend-subtitle legend-row">{legendTitle +"("+mapData.length+")"}</div>}
                        <div className='container-legend-content'>
                            {projectGroups?.length > 1 &&
                                projectGroups?.map((item, index) => {
                                    return (
                                        <Accordion key={index} defaultExpanded={true} square={true}>
                                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                {item.Group}
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                {item?.Projects.map((project, index2) => {
                                                    return (
                                                        <div className="legend-row" key={index2}>
                                                            <LegendStatusItem
                                                                size={project.count}
                                                                colourData={project.colorData}
                                                            />
                                                            <div className="legend-text">{project.discr}</div>
                                                        </div>
                                                    );
                                                })}
                                            </AccordionDetails>
                                        </Accordion>
                                    );
                                })}
                            {projectGroups?.length == 1 &&
                                projectGroups[0].Projects?.map((project, index) => {
                                    return (
                                        <div className="legend-row" key={index}>
                                            <LegendStatusItem size={project.count} colourData={project.colorData} />
                                            <div className="legend-text">{project.discr}</div>
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                )}

            </div>
            }
        </>
    );
}
